export const cities = [
  'New York, NY',
  'Los Angeles, CA', 
  'Chicago, IL',
  'Houston, TX',
  'Phoenix, AZ',
  'Philadelphia, PA',
  'San Antonio, TX',
  'San Diego, CA',
  'Dallas, TX',
  'San Jose, CA',
  'Miami, FL',
  'Fort Lauderdale, FL',
  'West Palm Beach, FL',
  'Boca Raton, FL',
  'Orlando, FL',
  'Tampa, FL',
  'Jacksonville, FL',
  'Naples, FL',
  'Sarasota, FL',
  'St. Petersburg, FL'
];

export const occupations = [
  'Software Engineer',
  'Product Manager',
  'Data Scientist',
  'UX Designer',
  'Marketing Manager',
  'Financial Analyst',
  'Business Analyst',
  'Project Manager',
  'Sales Manager',
  'Account Executive',
  'Teacher',
  'Doctor',
  'Nurse',
  'Lawyer',
  'Accountant',
  'Architect',
  'Chef',
  'Consultant',
  'Real Estate Agent',
  'Student'
];

export const languages = [
  'English',
  'Spanish',
  'French',
  'German',
  'Italian',
  'Portuguese',
  'Russian',
  'Chinese',
  'Japanese',
  'Korean',
  'Arabic',
  'Hindi',
  'Bengali',
  'Vietnamese',
  'Thai',
  'Turkish',
  'Polish',
  'Dutch',
  'Greek',
  'Hebrew'
];